export const GOOGLE_MAP_API = "AIzaSyACu57ulOOcyPbB5B5vcIms86VNDYxRVc0";
